module.exports = __webpack_public_path__ + "img/printer-fill.9fd3dff5.svg";